import React, {ReactNode, useEffect} from "react";
import Navbar from "./Navbar";
import "../styles/globals.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from "react-bootstrap";
import "./Layout.css";
import {useLocation} from "react-router-dom";

export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
}

export default function Layout({ children }: { children: ReactNode }) {
    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            <ScrollToTop /> {/* 👈 关键！ */}
            <Navbar />

            {/* 主内容区：使用 Bootstrap Container，但 xs 全宽，md+ 居中 */}
            <main className="flex-grow mt-5 mt-md-6 mb-6">
                <Container fluid className="px-3 px-md-4">
                    {/* 在 md 及以上屏幕限制最大宽度，避免文字行太长 */}
                    <div className="mx-auto" style={{ maxWidth: '1600px' }}>
                        {children}
                    </div>
                </Container>
            </main>
        </div>
    );
}